import "../../../../modal.scss";
import React, { useContext, useState, useEffect, useMemo, useRef } from "react";
import Modal from "react-modal";
import { ArticulosContext } from '../../../../../context/articulos/ArticulosContext';
import { getHeaders } from "./configGrid/headers";
import { formatRows } from "./configGrid/rows";
import { Paginator } from "../../../../../components/paginator/Paginator";
import { indice } from "../../../../../components/DataGrid/indice";
import { CircularProgress, LinearProgress } from "@mui/material";
import CustomDataGrid from "../../../../../components/DataGrid/CustomDataGrid";
import ConfirmDialog from "../../../../../components/dialogs/DeleteDialog";
import ErrorDialog from "../../../../../components/dialogs/ErrorDeleteDialog";
import FiltersGrid from './filtersGrid/filtersGrid';
import { fetchEntityData, deleteItem } from './configGrid/apiCalls';

Modal.setAppElement("#root"); // Necesario para accesibilidad

const DetalleFiltersModal = ({
  tipooferta,
  tipoprecio,
  addItem,
  closeModal,
}) => {
  const titleGrid = "Lista de Artículos Seleccionados Para Oferta";
  const contexto = useContext(ArticulosContext);
  const {
    getArticulosPanelData,
  } = contexto;

  const nameData = "articulos";
  const getData = getArticulosPanelData;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalDataItems, setTotalDataItems] = useState(0);

  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  //Estado para la importacion
  const [isImporting, setIsImporting] = useState(false);
  const [progress, setProgress] = useState(0);
  // Estado del buscador
  const [searchTerm, setSearchTerm] = useState("");
  const searchSelectRef = useRef();
  const [searchIDRam, setSearchIDRam] = useState();
  const [searchIDRub, setSearchIDRub] = useState();
  const [searchIDSubr, setSearchIDSubr] = useState();
  const [searchIDMar, setSearchIDMar] = useState();
  const [searchDescRam, setSearchDescRam] = useState();
  const [searchDescRub, setSearchDescRub] = useState();
  const [searchDescSubr, setSearchDescSubr] = useState();
  const [searchDescMar, setSearchDescMar] = useState();
  const [searchDes, setSearchDes] = useState("");
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Ref de input
  const searchInputRef = useRef(null);
  const isFetchingRef = useRef(false);
  // Estado para el modal de confirmación
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  // Estado para manejar el error
  const [error, setError] = useState("");
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);


  const [stock, setStock] = useState(0);
  const [totaloferta, setTotaloferta] = useState();
  const [porcentaje, setPorcentaje] = useState("");
  const [isDiscountApplied, setIsDiscountApplied] = useState(false); // Nueva bandera
  const hasFilters =
    searchTerm ||
    searchIDRam ||
    searchDescRam ||
    searchIDRub ||
    searchDescRub ||
    searchIDSubr ||
    searchDescSubr ||
    searchIDMar ||
    searchDescMar ||
    searchDes;

  useEffect(() => {

    if (hasFilters) {
      fetchData();
    }
  }, [searchTerm, searchIDRam, searchDescRam, searchIDRub, searchDescRub, searchIDSubr, searchDescSubr, searchIDMar, searchDescMar, searchDes, numPagina, filas]);

  // Dentro del componente `Datatable`
  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const { dataEntity, totalItems, totalPage, totalDataItems } = await fetchEntityData(
        getData,
        searchTerm,
        searchIDRam,
        searchIDRub,
        searchIDSubr,
        searchIDMar,
        searchDes,
        numPagina,
        filas,
      );

      if (numPagina > totalPage) {
        setNumPagina(totalPage);
      } else {
        setListaItems(dataEntity);
        setTotalItems(totalItems);
        setTotalDataItems(totalDataItems);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleSearch = () => {
    const value = searchInputRef.current?.value || ""; // Obtiene el valor del input
    setSearchTerm(value); // Actualiza el estado con el término de búsqueda
  };

  const handleDesChange = (e) => {
    setSearchDes(e.target.value);
  };

  const handleClear = () => {
    setSearchTerm("");
    if (searchInputRef.current) {
      searchInputRef.current.value = ""; // Limpia el input de búsqueda
    }
  };

  const handleClearDes = () => {
    setSearchDes("");
    if (searchSelectRef.current) {
      searchSelectRef.current.value = ""; // Limpia el input de búsqueda
    }
  };

  const handleStockChange = (e) => setStock(e.target.value);

  const handleDiscountChange = (e) => {
    let value = Number(e.target.value);

    if (value > 90) {
      setError("El descuento no puede ser mayor al 90%");
      value = 90; // Limita el valor máximo a 90
    } else {
      setError(""); // Limpia el mensaje de error si el valor es válido
    }
    setPorcentaje(value);

  };

  const applyFilters = () => {
    const descuento = porcentaje;

    const updatedItems = listaItems.map((item) => ({
      ...item,
      descuento,
      totaloferta,
      stock: stock || item.stock, // Solo cambia si se ha especificado
    }));
    setListaItems(updatedItems);
    setTotalItems(listaItems.length);
    setIsDiscountApplied(true); // Marca como aplicado
  };

  const handleDelete = (id) => {
    setListaItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  const headers = getHeaders(tipooferta, tipoprecio);
  const datosColum = useMemo(() => {
    if (!headers || !Array.isArray(headers)) {
      console.error("headers debe ser un array");
      return [];
    }

    const columnasComunes = indice(numPagina, filas);
    const columnasVisibles = headers.filter((column) => !column.hidden);

    return columnasComunes.concat(columnasVisibles, [
      {
        field: "acciones",
        headerName: "Acciones",
        width: 100,
        renderCell: (params) => (
          <button
            onClick={() => handleDelete(params.row.id)}
            style={{ background: "white", color: "red", border: "none", cursor: "pointer" }}
          >
            Eliminar
          </button>
        ),
      },
    ]);
  }, [numPagina, filas, headers]);

  const rows = useMemo(
    () => formatRows(listaItems, tipooferta, tipoprecio),
    [listaItems, tipoprecio]
  );

  const handleImport = async () => {
    if (rows.length === 0) {
      return;
    }

    setIsImporting(true); // Activar la barra de carga
    setProgress(0); // Reiniciar progreso

    // Simulación de proceso de importación
    for (let i = 0; i <= 100; i++) {
      await new Promise((resolve) => setTimeout(resolve, 50)); // Simula el tiempo de carga
      setProgress(i); // Actualiza el progreso
    }

    // Usar un bucle `for...of` para esperar que cada `addItem` se complete antes de pasar al siguiente
    for (const item of rows) {
      const generateRandomId = () => {
        return Math.floor(Math.random() * 1000000) + Date.now();
      };

      // Generar un nuevo ID aleatorio para cada nuevo registro
      const idNuevo = generateRandomId();
      let costoFinal = parseFloat(String(item.costo).replace("$", "").trim());
      let descFinal = parseFloat(item.descuento.replace("%", "").trim());
      let precioFinal = parseFloat(item.precio.replace("$", "").trim());
      let ofertaFinal = parseFloat(String(item.totaloferta).replace("$", "").trim());

      // Modificar el item con las propiedades necesarias
      item.art_Id = item.id;
      item.id = idNuevo; // Asignar nuevo ID
      item.art_codigo = item.codigo; // Asignar el código del artículo
      item.aofd_ofertacosto = parseFloat(costoFinal.toFixed(2)); // Redondear a 2 decimales y convertir a número flotante
      item.aofd_art_nprecio = parseFloat(precioFinal.toFixed(2)); // Redondear a 2 decimales y convertir a número flotante
      item.aofd_ofertadescto = parseFloat(descFinal.toFixed(2)); // Redondear a 2 decimales y convertir a número flotante
      item.aofd_margen = parseFloat(((ofertaFinal - costoFinal) / costoFinal) * 100).toFixed(2); // Calcular margen de oferta y redondear
      item.aofd_margenactual = parseFloat(((precioFinal - costoFinal) / costoFinal) * 100).toFixed(2); // Calcular margen actual y redondear
      item.aofd_ofertaprecio = parseFloat(ofertaFinal.toFixed(2)); // Redondear a 2 decimales y convertir a número flotante
      item.oferta_Art = {
        art_descripcion: item.descripcion, // Asignar descripción del artículo
      };
      item.aofd_ofertastock=item.totalstock;

      // Eliminar las propiedades no necesarias
      delete item.codigo;
      delete item.costo;
      delete item.descuento;
      delete item.precio;
      delete item.totaloferta;
      delete item.totalstock;

      // Llamar a `addItem` con el item modificado
      await addItem(item);
    }
    setIsImporting(false); // Desactivar la barra de carga
    // Cerrar el modal después de importar
    closeModal();
  };

  return (
    <div className="datatable">
      <div className="datatableTitle" style={{ position: "sticky", top: 0 }}>
        <h3>{titleGrid}</h3>
 
          <div className="inputsRow" style={{ display: "flex", gap: "10px", margin: "auto" }}>
            <FiltersGrid
              searchInputRef={searchInputRef}
              searchTerm={searchTerm}
              onSearch={handleSearch}
              onClose={handleClear}
              setSearchIDMar={setSearchIDMar}
              setSearchDescMar={setSearchDescMar}
              setSearchIDRam={setSearchIDRam}
              setSearchDescRam={setSearchDescRam}
              setSearchIDRub={setSearchIDRub}
              setSearchDescRub={setSearchDescRub}
              setSearchIDSubr={setSearchIDSubr}
              setSearchDescSubr={setSearchDescSubr}
              searchIDRam={searchIDRam}
              searchIDRub={searchIDRub}
              searchSelectRef={searchSelectRef}
              searchDes={searchDes}
              handleDesChange={handleDesChange}
              handleClearDes={handleClearDes}
            />
          </div>
          <div className="inputsRow" style={{ display: "flex", gap: "10px", margin: "auto" }}>
            {
              listaItems.length > 0 &&

              <>
                <div className="inputWrapper">
                  <label style={{ color: "black", fontSize: "16px" }}>Porcentaje:</label>
                  <input
                    type="number"
                    value={porcentaje}
                    onChange={handleDiscountChange}
                    placeholder="Ej: 10"
                    min="0"
                    max="90"
                    width={120}
                  />

                </div>


                {(Number(tipooferta) === 1 && listaItems.length > 0) && (
                  <div className="inputWrapper">
                    <label style={{ color: "black", fontSize: "16px" }}>Stock:</label>
                    <input
                      type="number"
                      value={stock}
                      onChange={handleStockChange}
                      placeholder="Ej: 50"
                      width={120}
                    />
                  </div>
                )}
                <button
                  style={{
                    background: "#007bff",
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    cursor: "pointer",
                  }}
                  onClick={applyFilters}
                >
                  Aplicar
                </button>

                <button
                  onClick={handleImport}
                  disabled={!isDiscountApplied || isImporting} // Deshabilitar mientras está importando
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                    background: "#007bff",
                    color: "#fff",
                    border: "none",
                    padding: "8px 16px",
                    cursor: isImporting ? "default" : "pointer",
                  }}
                >
                  {isImporting ? "Importando..." : "Importar"}
                </button>
              </>

            }

          </div>{error && <p style={{ color: "red", fontSize: "14px", fontWeight: "bold" }}>{error}</p>}
 
      </div>

      {isImporting ? (
        // Mostrar barra de progreso durante la importación
        <div className="loading">
          <h4>Cargando...</h4>
          <LinearProgress variant="determinate" value={progress} style={{ width: "100%" }} />
          <p>{progress}%</p>
        </div>
      ) : isLoading ? (
        // Mostrar círculo de carga si está cargando datos
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        </div>
      ) : (
        // Mostrar tabla si no está importando ni cargando
        <CustomDataGrid
          rows={rows}
          columns={datosColum}
          pageSize={filas}
          rowCount={totalItems}
          onPageChange={setNumPagina}
          onPageSizeChange={(newPageSize) => {
            setFilas(newPageSize);
            setNumPagina(1);
          }}
          isLoading={isLoading}
          enablePagination={false}
          enableSelectionClick={false}
        />
      )}
    </div>
  );
};
export default DetalleFiltersModal;
